import { useMemo, useState } from 'react';
import { Button, Collapse } from 'reactstrap';

const ErrorFallback = ({ error }) => {
  const [showStack, setShowStack] = useState(false);

  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <h1>
        <i className="fa fa-exclamation-triangle text-danger" />
      </h1>
      <span style={{ marginBottom: '8px' }}>
        <em>{error.message}</em>
      </span>
      <Button onClick={() => setShowStack(prev => !prev)}>Show stack trace</Button>
      <Collapse isOpen={showStack}>
        <div style={{ marginLeft: '8rem', marginRight: '8rem' }}>
          {error.stack.split('\n').map((ln, i) => (
            <div key={i}>{ln}</div>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default ErrorFallback;
